<template>
    <div class="article-content">
        <el-scrollbar class="article-wrap">
            <div class="top-tab">
                <el-breadcrumb separator-class="el-icon-arrow-right" class="genera-breadcrumb">
                    <el-breadcrumb-item>网络营销</el-breadcrumb-item>
                    <el-breadcrumb-item>{{socialECommerce_type}}</el-breadcrumb-item>
                    <el-breadcrumb-item>查看</el-breadcrumb-item>
                </el-breadcrumb>
                <div class="btn-box">
                    <el-button type="primary" @click="goBack">返回</el-button>
                </div>
            </div>
            <div class="main-content">
                <div class="main-wrap">
                    <div class="top-title">{{articleInfo.title}}</div>
                    <div class="top-author">{{articleInfo.author}}</div>
                    <div class="top-content" v-html="articleInfo.content"></div>
                </div>
            </div>
        </el-scrollbar>
    </div>
</template>

<script>
    import {StuOpSocialInfo} from '@/utils/apis'

    export default {
        name: "Detail",
        data() {
            return {
                articleId: Number(this.$route.query.article_id) || null,
                articleInfo: {
                    title: '',
                    content: '',
                    author: ''
                },
                //社交电商类型
                socialECommerce_type: '',
                social_type: Number(this.$route.query.social_type) || null,
            }
        },
        created() {
            this.getEditList();
            if (this.social_type === 1) {
                this.socialECommerce_type = '软文营销';
            }
            if (this.social_type === 2) {
                this.socialECommerce_type = '短视频营销';
            }
            if (this.social_type === 3) {
                this.socialECommerce_type = '直播营销';
            }
        },
        methods: {
            //获取软文详情
            getEditList() {
                StuOpSocialInfo(this.articleId).then(res => {
                    this.articleInfo.title = res.data.title;
                    this.articleInfo.content = res.data.content;
                    this.articleInfo.author = res.data.author;
                }).catch(err => {
                    console.error(err)
                })
            },
            goBack() {
                this.$router.go(-1)
            },
        }
    }
</script>

<style scoped lang="scss">
    .article-content {
        display: flex;
        flex-direction: column;
        height: calc(100% - 50px);
        padding: 0 0 50px;

        .article-wrap {
            height: 100%;
            display: flex;
            flex-direction: column;

            ::v-deep > .el-scrollbar__wrap {
                overflow-x: hidden;

                .el-scrollbar__view {
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                    padding: 0 20px;
                }
            }
        }

        .top-tab {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #F1F5FF;
            height: 40px;
            padding-bottom: 10px;

            .genera-breadcrumb {
                display: flex;
                align-items: center;

                &:before {
                    content: unset;
                }
            }
        }

        .main-content {
            margin-top: 20px;
            flex: 1;
            height: 1%;

            .main-wrap {
                width: 900px;
                margin: 0 auto;
                height: 100%;

                .top-title {
                    text-align: center;
                    font-size: 20px;
                    color: #333333;
                }

                .top-author {
                    margin-top: 12px;
                    text-align: center;
                    font-size: 14px;
                    color: #666666;
                }

                .top-content {
                    margin-top: 20px;

                    ::v-deep p {
                        img {
                            max-width: 900px;
                        }
                    }
                }
            }
        }
    }
</style>